<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <br><br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    BXI Apps - {{ _.startCase(selectedProfile)}}
                </base-button>
                <!-- <template v-if='isAccountOwner==false'>
                    <a @click.prevent="setCurrentProfile('wavelet_manager')" class="dropdown-item" href="#">Wavelet Manager</a>
                </template> -->
                <template>
                    <a @click.prevent="setCurrentProfile('app_settings')" class="dropdown-item" href="#">My Apps</a>
                    <a @click.prevent="setCurrentProfile('app_marketplace')" class="dropdown-item" href="#">App Marketplace</a>
                </template>


            </base-dropdown>
        </base-header>
        <!-- <div v-if="selectedProfile == 'wavelet_manager'" class="container-fluid mt--7">
            <wavelet-manager />
        </div> -->
        <div v-if="selectedProfile == 'app_settings'" class="container-fluid mt--7">
            <app-settings />
        </div>
        <div v-if="selectedProfile == 'app_marketplace'" class="container-fluid mt--7">
            <app-marketplace />
        </div>
    </div>
</template>


<script>
    // import WaveletManager from '../Wavelet/WaveletManager.vue'
    import AppSettings from '../Wavelet/AppSettings.vue'
    import AppMarketplace from '../Wavelet/AppMarketplace.vue'
    import secureStorage from '../../controllers/secureStorage';

    export default {
        components:{
            AppSettings, AppMarketplace
        },
        mounted: async function(){  
            if (this.isAccountOwner==true) {
                this.selectedProfile = "app_marketplace"
            }
        },
        computed: {
  
        },
        data() {
          return {
            isAccountOwner: secureStorage.getItem("isAccountOwner"),
            selectedProfile: "app_marketplace",
           
          }
        },
        methods: {
            setCurrentProfile(profile){
                this.selectedProfile = profile
            },
        }
    }
</script>

<style>
.ant-steps-item-process .ant-steps-item-icon {
    background: #65CB8F;
    border: #65CB8F;
}
.fix-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
}
</style>


